import { ActionReducerMapBuilder, createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../config/Api";
import { CartType, CartItemType, CartItemTypeRes } from "../../types/cartItemType";

import { ApiResponse } from "../../types/apiResponse";
import { sumCartItemMrpPrice, sumCartItemSellingPrice } from "../../utils/sumCartItem";





// createAsyncThunk<TypeofReturn,Type of Argument>
export interface AddItemRequest {
    size: string | undefined,
    color: string |undefined,
    quantity: number,
    productId: number | undefined;
}


// Good question! Let’s break it down. createAsyncThunk does indeed accept three type arguments, not just two.

// The full TypeScript signature of createAsyncThunk looks like this:

// typescript
// Copy code
// createAsyncThunk<
//     Returned,              // Type of the value returned when the thunk resolves
//     ThunkArg,              // Type of the argument passed into the thunk
//     ThunkApiConfig         // Optional configuration for the thunk's API
// >
// Explanation of the Three Arguments
// Returned (First Type Argument):

// The type of the data returned on success by the createAsyncThunk function.
// In your case, it’s Cart (the type of the resolved data).
// typescript
// Copy code
// createAsyncThunk<Cart, ...>
// ThunkArg (Second Type Argument):

// The type of the argument passed into the thunk function when it is dispatched.
// In this case, void means no argument is required for this thunk.
// typescript
// Copy code
// createAsyncThunk<Cart, void, ...>
// ThunkApiConfig (Third Type Argument):

// This is an optional configuration object that allows you to:

// Specify the type of the rejectValue returned from rejectWithValue.
// Define additional properties like state or dispatch for type safety.

export const findUserCartHandler = createAsyncThunk<CartType, void, { rejectValue: ApiResponse<null> }>("cart/findUserCartHandler",
    async (_, { rejectWithValue }) => {

        try {
            const response = await api.get("/api/cart")
          
            return response.data as CartType
        } catch (error: any) {
       
            return rejectWithValue(

                error.response?.data.message || "Failed to load Cart"
            )
        }
    }
)

// createAsyncThunk<TypeReturn,Type Arg>
export const addCartItemToCart = createAsyncThunk<CartItemTypeRes, AddItemRequest, { rejectValue: ApiResponse<null> }>("cart/addCartItemToCart",
    async (addItemRequest, { rejectWithValue }) => {
        try {
            const response = await api.post("/api/cart/add", addItemRequest)
       
            return response.data as CartItemTypeRes
        } catch (error: any) {
           
            return rejectWithValue({
                message: error.response?.data?.message || "Failed to load cart",
                success: false,
                data: null
            });
        }
    })

    // createAsyncThunk<TypeReturn,Type Arg>
export const resetCart = createAsyncThunk<CartType,void,{ rejectValue: ApiResponse<null> }>("cart/resetCart",
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.delete("/api/cart/reset")
           
            return response.data as CartType
        } catch (error: any) {
            return rejectWithValue({
                message: error.response?.data?.message || "Failed to reset cart",
                success: false,
                data: null
            });
        }
    })
// need to group because async Thunk only accept 1 type of arg same with result 
export const updateCartItemHandler = createAsyncThunk<CartItemTypeRes, CartItemType, { rejectValue: ApiResponse<null> }>("cart/updateCartItemHandler",
    async (cartItem, { rejectWithValue }) => {
        try {
            const response = await api.put(`/api/cart/item/update/${cartItem.id}`, cartItem)
            return response.data 
        } catch (error: any) {
          
            return rejectWithValue({
                message: error.response?.data?.message || "Failed to load cart",
                success: false,
                data: null
            });
        }
    }
)

export const deleteCartItemHandler = createAsyncThunk<ApiResponse<any>, number, { rejectValue: ApiResponse<null> }>("cart/deleteCartItemHandler",
    async (cartItemId, { rejectWithValue }) => {
        try {
            const response = await api.delete(`/api/cart/item/${cartItemId}`)
            return response.data
        } catch (error: any) {
            
            return rejectWithValue({
                message: error.response?.data?.message || "Failed to load cart",
                success: false,
                data: null
            });
        }
    }
)

interface CartItemState {
    cart: CartType,
    
  
    loading: boolean,
    error: ApiResponse<any> | null | undefined,
    isDeleted: boolean,
   
}

const initialState: CartItemState = {
    cart:{
         id: null,
            user: {},
            cartItems: [],
            totalSellingPrice: 0,
            totalItem: 0,
            totalMrpPrice:0,
            discount: 0,
            couponCode: "",
            totalSellingPriceForEachItem:0,
    },
    // Will hold the CartItemType[]
    loading: false,
    error: null,
    isDeleted: false,
    
}

export const cartItemSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        resetCartState:(state)=>{
            state.cart={
                id: null,
                   user: {},
                   cartItems: [],
                   totalSellingPrice: 0,
                   totalItem: 0,
                   totalMrpPrice:0,
                   discount: 0,
                   couponCode: "",
                   totalSellingPriceForEachItem:0,
           };
            state.loading=false;
            state.error=null
        },
    },
    extraReducers: (builder: ActionReducerMapBuilder<CartItemState>) => {
        builder
            .addCase(findUserCartHandler.pending, (state) => {
                state.loading = true;
            })
            .addCase(findUserCartHandler.fulfilled, (state, action: PayloadAction<CartType>) => {
                state.loading = false;
              
                state.cart = action.payload   // Assume action.payload is a fully populated CartType object
                // if (state.cart && state.cart.cartItems) {
                //     const mrpPrice = sumCartItemMrpPrice(state.cart.cartItems);
                //     const sellingPrice = sumCartItemSellingPrice(state.cart.cartItems);
                    
                //     state.cart.totalSellingPrice = sellingPrice;
                //     state.cart.totalMrpPrice = mrpPrice;
                    
                // }
                
            })
            .addCase(findUserCartHandler.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(addCartItemToCart.pending, (state) => {
                state.loading = true;
            })
            .addCase(addCartItemToCart.fulfilled, (state, action: PayloadAction<CartItemTypeRes>) => {
               if(state.cart?.cartItems){

                   // Now you can safely push to cartItems
                   state.cart.cartItems.push(action.payload);
               }
            })

          

            .addCase(addCartItemToCart.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateCartItemHandler.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateCartItemHandler.fulfilled, (state, action: PayloadAction<CartItemTypeRes>) => {
                state.loading = false;
                const index = state.cart && state.cart.cartItems ? state.cart.cartItems.findIndex(item => item.id === action.payload.id) : -1;
                if (index !== -1) {
                    state.cart.cartItems[index] = action.payload;
                    if (state.cart && state.cart.cartItems) {
                        const mrpPrice = sumCartItemMrpPrice(state.cart.cartItems);
                        const sellingPrice = sumCartItemSellingPrice(state.cart.cartItems);
                        
                        state.cart.totalSellingPrice = sellingPrice;
                        state.cart.totalMrpPrice = mrpPrice;
                        
                    }
                }
            })
            .addCase(updateCartItemHandler.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
              // reset cart

            .addCase(resetCart.pending, (state) => {
                state.loading = true;
            })
            .addCase(resetCart.fulfilled, (state, action: PayloadAction<CartType>) => {
                state.loading = false;
              
                state.cart = action.payload   // Assume action.payload is a fully populated CartType object
                if (state.cart && state.cart.cartItems) {
                    const mrpPrice = sumCartItemMrpPrice(state.cart.cartItems);
                    const sellingPrice = sumCartItemSellingPrice(state.cart.cartItems);
                    
                    state.cart.totalSellingPrice = sellingPrice;
                    state.cart.totalMrpPrice = mrpPrice;
                    
                }
                
            })
            .addCase(resetCart.rejected, (state, action:PayloadAction<any>) => {
                state.loading = false;
                state.error = action.payload;
            })




            .addCase(deleteCartItemHandler.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteCartItemHandler.fulfilled, (state, action) => {
                state.loading = false;
                if (state.cart && state.cart.cartItems) {
                    state.cart.cartItems = state.cart.cartItems.filter(item => item.id !== action.meta.arg);  // Assuming action.meta.arg is cartItemId
                    const mrpPrice = sumCartItemMrpPrice(state.cart.cartItems);
                    const sellingPrice = sumCartItemSellingPrice(state.cart.cartItems);
                    
                    state.cart.totalSellingPrice = sellingPrice;
                    state.cart.totalMrpPrice = mrpPrice;
                }
            })
            .addCase(deleteCartItemHandler.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
})

export const cartItemSliceReducer = cartItemSlice.reducer

export const {resetCartState}= cartItemSlice.actions